var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var _a;
import _classNames from 'clsx';
import * as React from 'react';
import { Component, createRef } from 'react';
import Button from '../../button/button';
import Callout from '../../callout/callout';
import ComplexIcon from '../../icons/ComplexIcon/ComplexIcon';
import Loader from '../../loader/loader';
export var FILETYPE;
(function (FILETYPE) {
    FILETYPE["CSV"] = "text/csv";
})(FILETYPE || (FILETYPE = {}));
/**
 * With this component, a user can drag and drop a file to upload.
 */
var UploadArea = /** @class */ (function (_super) {
    __extends(UploadArea, _super);
    function UploadArea(props) {
        var _this = _super.call(this, props) || this;
        _this.dropRef = createRef();
        // exposed for testing
        _this.fileInput = createRef();
        _this.handleDragEvent = function (e) {
            e.preventDefault();
            e.stopPropagation();
            // dragover event type must be included to prevent browser default behavior (opening or downloading file)
            if (e.type === 'dragover')
                return;
            var dragCounter = _this.state.dragCounter;
            var uploadSuccessful = _this.props.uploadSuccessful;
            if (uploadSuccessful)
                return;
            if (e.type === 'dragenter' && e.dataTransfer.items && e.dataTransfer.items.length > 0) {
                _this.setState(function (state) { return ({
                    dragCounter: state.dragCounter + 1,
                    dragging: true,
                }); });
            }
            else if (e.type === 'dragleave' && dragCounter === 1) {
                _this.setState({
                    dragCounter: 0,
                    dragging: false,
                });
            }
            else if (e.type === 'dragleave' && dragCounter > 1) {
                _this.setState(function (state) { return ({
                    dragCounter: state.dragCounter - 1,
                }); });
            }
        };
        _this.handleDrop = function (e) {
            var _a = _this.props, acceptFileType = _a.acceptFileType, uploadSuccessful = _a.uploadSuccessful, _b = _a.onDrop, onDrop = _b === void 0 ? function () { } : _b, _c = _a.onMultipleFiles, onMultipleFiles = _c === void 0 ? function () { } : _c, _d = _a.onFileTypeError, onFileTypeError = _d === void 0 ? function () { } : _d;
            e.preventDefault();
            e.stopPropagation();
            if (uploadSuccessful)
                return;
            _this.setState({ dragging: false });
            if (e.dataTransfer.files &&
                e.dataTransfer.files.length === 1 &&
                e.dataTransfer.files[0].type === acceptFileType) {
                onDrop();
                _this.fileInput.current.files = e.dataTransfer.files;
                _this.handleFiles();
                _this.setState({
                    dragCounter: 0,
                    error: '',
                });
                e.dataTransfer.clearData();
            }
            else if (e.dataTransfer.files && e.dataTransfer.files.length > 1) {
                _this.setState({
                    error: "Cannot read multiple files.  Please upload (1) ".concat(UploadArea.FILETYPE_TO_STRING_MAP[acceptFileType], " file at a time."),
                });
                onMultipleFiles(e.dataTransfer.files.length);
            }
            else if (e.dataTransfer.files && e.dataTransfer.files[0].type !== acceptFileType) {
                _this.setState({
                    error: "Unsupported file type. Supported files should include the \".".concat(UploadArea.FILETYPE_TO_STRING_MAP[acceptFileType].toLowerCase(), "\" file extension."),
                });
                // passing file extension as arg
                onFileTypeError(e.dataTransfer.files[0].name.split('.').pop());
            }
        };
        _this.handleSubmit = function (e) {
            e.preventDefault();
            var onUpload = _this.props.onUpload;
            var fileData = _this.state.fileData;
            onUpload(fileData);
        };
        _this.handleFiles = function () {
            var _a;
            var _b = _this.props, fileNotCompatible = _b.fileNotCompatible, onRemoveFile = _b.onRemoveFile;
            _this.setState({ error: '' });
            if (_this.fileInput.current.files.length === 0) {
                return;
            }
            _this.setState({
                showLoader: true,
                fileData: (_a = _this.fileInput.current) === null || _a === void 0 ? void 0 : _a.files[0],
            });
            if (fileNotCompatible) {
                onRemoveFile();
            }
            // using generic setTimeout to show loader animation once as visual feedback for the user
            setTimeout(function () { return _this.setState({ showLoader: false }); }, 1000);
        };
        _this.handleRemoveFile = function () {
            var onRemoveFile = _this.props.onRemoveFile;
            _this.setState({ fileData: null });
            _this.fileInput.current.value = '';
            onRemoveFile();
        };
        _this.handleReplaceFile = function (e) {
            var _a = _this.props.onReplace, onReplace = _a === void 0 ? function () { } : _a;
            onReplace();
            UploadArea.handleFileButton(e);
        };
        _this.handleSelectFile = function (e) {
            var _a = _this.props.onSelectFile, onSelectFile = _a === void 0 ? function () { } : _a;
            onSelectFile();
            UploadArea.handleFileButton(e);
        };
        _this.handleSelectNew = function (e) {
            var _a = _this.props.onSelectNew, onSelectNew = _a === void 0 ? function () { } : _a;
            onSelectNew();
            UploadArea.handleFileButton(e);
        };
        _this.state = {
            dragCounter: 0,
            dragging: false,
            error: '',
            fileData: null,
            showLoader: false,
        };
        return _this;
    }
    UploadArea.prototype.componentDidMount = function () {
        var div = this.dropRef.current;
        div.addEventListener('dragenter', this.handleDragEvent);
        div.addEventListener('dragleave', this.handleDragEvent);
        div.addEventListener('dragover', this.handleDragEvent);
        div.addEventListener('drop', this.handleDrop);
    };
    UploadArea.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _a;
        var fileData = this.state.fileData;
        var _b = this.props.onFileChange, onFileChange = _b === void 0 ? function () { } : _b;
        if (onFileChange && (fileData === null || fileData === void 0 ? void 0 : fileData.name) !== ((_a = prevState.fileData) === null || _a === void 0 ? void 0 : _a.name)) {
            onFileChange(fileData);
        }
    };
    UploadArea.prototype.componentWillUnmount = function () {
        var div = this.dropRef.current;
        div.removeEventListener('dragenter', this.handleDragEvent);
        div.removeEventListener('dragleave', this.handleDragEvent);
        div.removeEventListener('dragover', this.handleDragEvent);
        div.removeEventListener('drop', this.handleDrop);
    };
    UploadArea.prototype.render = function () {
        var _a = this.props, infoText = _a.infoText, isUploading = _a.isUploading, actionText = _a.actionText, acceptFileType = _a.acceptFileType, fileNotCompatible = _a.fileNotCompatible, uploadError = _a.uploadError, uploadSuccessful = _a.uploadSuccessful;
        var _b = this.state, dragging = _b.dragging, fileData = _b.fileData, error = _b.error, showLoader = _b.showLoader;
        var fileinputDomId = 'fileinput';
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: _classNames('UploadArea', {
                    'UploadArea--dragging': dragging,
                    'UploadArea--hasFileData': fileData,
                }), ref: this.dropRef },
                React.createElement(Loader, { isLoading: showLoader, classes: "UploadArea__loader" }),
                React.createElement("div", { className: "UploadArea__form" },
                    fileData ? (React.createElement("div", { className: "UploadArea__fileData" },
                        React.createElement(ComplexIcon, { name: "csv-icon", classes: "UploadArea__fileIcon" }),
                        React.createElement("div", null,
                            React.createElement("p", { className: "UploadArea__fileData__name" }, fileData.name),
                            React.createElement("p", { className: "UploadArea__fileData__size" }, UploadArea.getFileSizeString(fileData.size))))) : (React.createElement("div", { className: "UploadArea__instructions" }, infoText || 'Select a file or drag and drop here.')),
                    React.createElement("div", null,
                        React.createElement("input", { className: "UploadArea__input", type: "file", id: fileinputDomId, name: "fileinput", accept: acceptFileType || FILETYPE.CSV, ref: this.fileInput, onChange: this.handleFiles }),
                        fileData && !uploadSuccessful && (React.createElement(React.Fragment, null,
                            React.createElement(Button, { type: "secondary", classes: "UploadArea__button--fileReady", buttonProps: { type: 'button' }, onKeyDown: UploadArea.handleFileButton, onClick: this.handleReplaceFile },
                                React.createElement("label", { htmlFor: fileinputDomId, className: "UploadArea__button" }, "Replace file")),
                            React.createElement(Button, { buttonProps: { type: 'submit' }, type: "primary", onClick: this.handleSubmit, classes: "UploadArea__button--fileReady", loading: isUploading }, actionText || 'Upload file'))),
                        !fileData && !uploadSuccessful && (React.createElement(Button, { type: "primary", buttonProps: { type: 'button' }, onClick: this.handleSelectFile, classes: "UploadArea__button" },
                            React.createElement("label", { htmlFor: fileinputDomId, className: "UploadArea__button" }, "Select file"))),
                        fileData && uploadSuccessful && !fileNotCompatible && (React.createElement(Button, { type: "destructiveMinor", buttonProps: { type: 'button' }, onClick: this.handleRemoveFile, classes: "UploadArea__button" }, "Remove file")),
                        fileData && uploadSuccessful && fileNotCompatible && (React.createElement(Button, { type: "primary", buttonProps: { type: 'button' }, onClick: this.handleSelectNew, classes: "UploadArea__button" },
                            React.createElement("label", { htmlFor: "fileinput", className: "UploadArea__button" },
                                "Select new ",
                                UploadArea.FILETYPE_TO_STRING_MAP[acceptFileType])))))),
            (uploadError || error) && (React.createElement("div", { className: "UploadArea__errorMessage" },
                React.createElement(Callout, { text: uploadError || error, type: Callout.TYPE.ERROR, defaultIcon: true, iconColor: Callout.THEME.COLOR })))));
    };
    UploadArea.FILETYPE_TO_STRING_MAP = (_a = {},
        _a[FILETYPE.CSV] = 'CSV',
        _a);
    UploadArea.getFileSizeString = function (size) {
        var byteValue = '';
        var unit = '';
        if (size < 1000) {
            byteValue = Math.round(size).toString();
            unit = 'B';
        }
        else if (size >= 1000 && size < 1000000) {
            byteValue = Math.round(size / 1000).toString();
            unit = 'KB';
        }
        else if (size >= 1000000 && size < 1000000000) {
            byteValue = Math.round(size / 1000000).toString();
            unit = 'MB';
        }
        else if (size >= 1000000000) {
            byteValue = Math.round(size / 1000000000).toString();
            unit = 'GB';
        }
        return "".concat(byteValue, " ").concat(unit);
    };
    UploadArea.handleFileButton = function (e) {
        // keyCode only exists in KeyboardEvent and button only exists in MouseEvent
        // 13 is return/enter, 32 is space
        if (('keyCode' in e && (e.keyCode === 13 || e.keyCode === 32)) || 'button' in e) {
            e.preventDefault();
            document.getElementById('fileinput').click();
        }
    };
    return UploadArea;
}(Component));
export default UploadArea;
